import React from 'react';
import './Road.css';
// import ReactTransitionGroup from 'react-addons-transition-group'
// import TransitionGroup from 'react-transition-group/TransitionGroup'

class Road extends React.Component {
  render() {
    return (
      <div className="road">
        <div className="road-line" />
        <div className="road-line" />
        <div className="road-line" />
      </div>
    );
  }
}

export default Road;



// WEBPACK FOOTER //
// ./src/components/road/Road.js